export default __webpack_public_path__ + "static/vos-douglas-ff0d1a199995b0e0a2a6a75f53e015ed.mp4";